/*
 * File: notes.service.ts
 * Project: a-a
 * File Created: Monday, 14th April 2025 4:31:08 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Friday, 18th July 2025 12:04:04 am
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import axios from '../core/axios';
import { INotesAddPayload, INotesDeletePayload, INotesEditPayload } from '../model/notes.model';

import { ApiConstants } from './api-constants';
export class NotesService {
  static getAllNotes = async (id: string) => {
    return await (
      await axios.get(ApiConstants.NOTES_API.ALL_NOTES.URL(id))
    ).data;
  };
  static addNotes = async (params: INotesAddPayload) => {
    return await (
      await axios.post(ApiConstants.NOTES_API.ADD_EDIT_NOTES.URL(), params)
    ).data;
  };
  static EditNotes = async (params: INotesEditPayload) => {
    return await (
      await axios.patch(ApiConstants.NOTES_API.ADD_EDIT_NOTES.URL(), params)
    ).data;
  };
  static deleteNotes = async (id: string, params: INotesDeletePayload) => {
    return await (
      await axios.delete(ApiConstants.NOTES_API.ALL_NOTES.URL(id), { data: { ...params } })
    ).data;
  };
}
